import React, { useState } from "react";
import { Form, Input, Select, Button, Upload, DatePicker, message, Row, Col } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Axios from "../../../services/AxiosInterceptor";

const { Option } = Select;

const Members = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const navigate=useNavigate()

const onFinish = async (values) => {
    try {
      setLoading(true);
  
      // ✅ Convert DatePicker format
      const formattedValues = {
        ...values,
        joiningDate: values.joiningDate.format("YYYY-MM-DD"),
      };
  
      // ✅ Create FormData
      const formData = new FormData();
      for (const key in formattedValues) {
        formData.append(key, formattedValues[key]);
      }
  
      // ✅ Attach Medical Report File (Optional)
      if (values.medicalReport?.length > 0) {
        formData.append("medicalReport", values.medicalReport[0].originFileObj);
      }
  
      // ✅ Debug: Check FormData Content
      for (let pair of formData.entries()) {
        console.log(pair[0], pair[1]);
      }
  
      // ✅ Send Data to API
      const response = await Axios.post("api/register_member", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
  
      if (response.data.success) {
        message.success("Member registered successfully! 🎉");
        form.resetFields();
        navigate("/Member_List");
      } else {
        message.error(response.data.message);
      }
    } catch (error) {
      console.error("Error registering member:", error);
      message.error("Registration failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  
  

  return (
    <div >
      <h2 style={{ textAlign: "center", marginBottom: "20px" }}>🧘 Register a New Member</h2>
      <Form form={form} layout="vertical" onFinish={onFinish} autoComplete="off">
        
        {/* Row 1: Name, Email, Age */}
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item label="Full Name" name="name" rules={[{ required: true, message: "Please enter member's name!" }]}>
              <Input placeholder="Enter full name" />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Email" name="email" rules={[
                { required: true, message: "Please enter email!" },
                { type: "email", message: "Enter a valid email!" },
              ]}
            >
              <Input placeholder="Enter email" />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Age" name="age" rules={[{ required: true, message: "Please enter age!" }]}>
              <Input type="number" placeholder="Enter age" min={5} max={100} />
            </Form.Item>
          </Col>
        </Row>

        {/* Row 2: Gender, Yoga Experience, Membership Duration */}
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item label="Gender" name="gender" rules={[{ required: true, message: "Please select gender!" }]}>
              <Select placeholder="Select gender">
                <Option value="male">Male</Option>
                <Option value="female">Female</Option>
                <Option value="other">Other</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Yoga Experience" name="experience" rules={[{ required: true, message: "Please select an option!" }]}>
              <Select placeholder="Select an option">
                <Option value="yes">Yes</Option>
                <Option value="no">No</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Membership Duration" name="membership" rules={[{ required: true, message: "Select membership duration!" }]}>
              <Select placeholder="Select duration">
                <Option value="1_month">1 Month</Option>
                <Option value="2_months">2 Months</Option>
                <Option value="3_months">3 Months</Option>
                <Option value="6_months">6 Months</Option>
                <Option value="1_year">1 Year</Option>
                <Option value="2_year">2 Year</Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>

        {/* Row 3: Yoga Type, Illness, Fee */}
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item label="Yoga Type" name="yogaType" rules={[{ required: true, message: "Please select yoga type!" }]}>
              <Select placeholder="Select yoga type">
                <Option value="hatha">Hatha Yoga</Option>
                <Option value="power">Power Yoga</Option>
                <Option value="ashtanga">Ashtanga Yoga</Option>
                <Option value="kundalini">Kundalini Yoga</Option>
                <Option value="therapy">Therapeutic Yoga</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Illness (if any)" name="illness">
              <Input placeholder="Mention illness if any" />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Fee Paid (₹)" name="fee" rules={[{ required: true, message: "Please enter fee amount!" }]}>
              <Input type="number" placeholder="Enter amount" />
            </Form.Item>
          </Col>
        </Row>

        {/* Row 4: Medical Report Upload, Joining Date */}
        <Row gutter={16}>
          <Col span={12}>
        
            <Form.Item 
  label="Medical Report (Optional)" 
  name="medicalReport"
  valuePropName="fileList"
  getValueFromEvent={(e) => e.fileList}
  rules={[{ required: false }]}
>
  <Upload beforeUpload={() => false} listType="picture" accept=".pdf">
    <Button icon={<UploadOutlined />}>Upload Medical Report (PDF)</Button>
  </Upload>
</Form.Item>

          </Col>
          <Col span={12}>
            <Form.Item label="Joining Date" name="joiningDate" rules={[{ required: true, message: "Please select joining date!" }]}>
              <DatePicker style={{ width: "100%" }} />
            </Form.Item>
          </Col>
        </Row>
        <Row>
            <Col span={12}>
            <Form.Item label="Address"  name="address" rules={[{ required: true, message: "Please enter Address " }]}>
              <Input type="Text" placeholder="Enter Address"  style={{height:"70px",width:"100%"}}/>
            </Form.Item>
          </Col>
        </Row>

        {/* Submit Button */}
        <Form.Item>
          <Button htmlType="submit" loading={loading} style={{ width: "25%", background: "#DBA400" }}>
            Register Member
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default Members;
